<template>
<div id="page-usuarios" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Usuarios de MxTransmite" class="px-5 py-3" style="padding-bottom: 100px !importan" >

                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <exportar-excel :data="datafiltered" :exportFields="usuarios.camposexcel" name="Usuarios.xlsx" >
                            <v-btn fab dark x-small color="success" title="Exportar a Excel" v-tippy>
                                <v-icon dark>get_app</v-icon>
                            </v-btn>
                        </exportar-excel>
                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="500px" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >{{
                        update ? "edit" : "add"
                      }}</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} Usuario</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-form ref="form" lazy-validation>
                                        <v-container grid-list-md @keyup.enter="update ? updateUsuario() : saveUsuario()" >
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <v-text-field label="Nombre" v-model="model.nombre" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <v-text-field label="Apellidos" v-model="model.apellidos" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <v-text-field label="Iniciales" v-model="model.iniciales" @input="model.iniciales = model.iniciales.toUpperCase()" maxlength=15 :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <v-text-field label="Email" v-if="!update" v-model="model.username" :rules="[rules.required, rules.email]" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <v-select :items="tipos_usuario" v-model="model.tipo_usuario" label="Tipo de Usuario" item-text="nombre" item-value="id_tipo_usuario" :rules="[rules.required]" ></v-select>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-select v-if="model.tipo_usuario == 4" :items="grupos" v-model="model.grupo" item-text="nombre" item-value="id_grupo" label="Grupo" required :rules="
                                                        model.tipo_usuario == 4 ? [rules.required] : []" >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-select clearable v-if="model.tipo_usuario == 4" :items="perfiles" v-model="model.perfil" item-text="nombre" item-value="id_perfil" label="Perfil" >
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="update ? updateUsuario() : saveUsuario()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="usuarios.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="nombre" slot-scope="props" >
                                    <span>{{props.row.nombre + " " + props.row.apellidos}}</span>
                                </template>

                                <template slot="tipo_usuario" slot-scope="props" >
                                    <span>{{getNombreTipoUsuario(props.row.tipo_usuario)}}</span>
                                </template>

                                <template slot="grupo" slot-scope="props" >
                                    <div v-if="props.row.grupo > 0" >
                                        {{ getNombreGrupo(props.row.grupo) }}
                                    </div>
                                </template>

                                <template slot="perfil" slot-scope="props" >
                                    <div v-if="props.row.perfil !== null" @click="openModalPermisos(props.row.perfil)" :class="['showPerfil']" >
                                        {{ getNombrePerfil(props.row.perfil) }}
                                    </div>
                                    <div v-else-if="props.row.grupo > 0" >ADMINISTRADOR</div>                                    
                                </template>
                                
                                <template slot="estatus" slot-scope="props" >
                                    <div v-if="props.row.estatus" >Activo</div>
                                    <div v-if="!props.row.estatus" >Inactivo</div>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-btn v-if="props.row.tipo_usuario==4" x-small fab dark color="info" @click.native="
                                            openModalCliente(props.row.id_usuario, props.row.nombre, props.row.apellidos)
                                            " title="Cambiar a Cliente" v-tippy>
                                            <v-icon>person</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="green" v-if="!props.row.estatus" @click.native="
                          changeEstatus(props.row.id_usuario, true)
                        " title="Activar Usuario" v-tippy>
                                            <v-icon>check</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="orange" v-if="props.row.estatus" @click.native="
                          changeEstatus(props.row.id_usuario, false)
                        " title="Desactivar Usuario" v-tippy>
                                            <v-icon>block</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="getUsuario(props.row.id_usuario)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteUsuario(props.row.id_usuario)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="indigo" @click.native="
                          resetPassword(
                            props.row.id_usuario,
                            props.row.username
                          )
                        " title="Resetear Contraseña" v-tippy>
                                            <v-icon>lock</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="purple" @click.native="
                          logout(props.row.id_usuario)
                        " title="Cerrar Sesión" v-tippy>
                                            <v-icon>report_problem</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

    <v-dialog v-model="modal_cliente" max-width="40%" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" >reorder</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Cambiar usuario a cliente</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modal_cliente = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-form ref="formCliente" lazy-validation="" >
                    <v-container>
                        <v-layout>
                            <v-flex xs12>
                                Cambiar usuario: {{nombre_usuario_seleccionado}} a cliente.
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12>
                                <v-select :items="clientes" v-model="id_cliente" item-text="nombre" item-value="id_cliente" label="Seleccione Cliente" required 
                                :rules="[rules.required]" >
                                </v-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal_cliente = false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="convertirUsuario()" >
                    <v-icon>done</v-icon>Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="modal_permisos" max-width="40%" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modal_permisos = false" class="white--text" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>{{ titleModalPermisos }}</strong>
                    </span>
                </v-card>                
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-data-table :items="permisos_perfiles" class="elevation-1" :headers="permisos.headers" >
                    <template slot="no-data" >
                        <v-alert :value="true" color="error" icon="warning" >
                            No hay permisos en este perfil...
                        </v-alert>
                    </template>

                    <template slot="items" slot-scope="permiso" >
                        <td>{{ permiso.item.categoria }}</td>
                        <td>{{ permiso.item.nombre }}</td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import objectRenameKeys from "object-rename-keys";

import axios from "axios";

export default {
    mounted: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');        
  
        this.getPerfiles();
        this.getClientes();
        this.getTiposUsuario();
    },

    components: {},
    data() {
        return {
            titleModalPermisos: "",                        
            modal_permisos: false,            
            permisos_perfiles: [],
            permisos: {
                headers: [{
                        text: "Categoría",
                        value: "categoria"
                    },
                    {
                        text: "Permiso",
                        value: "nombre"
                    }
                ]
            },
            fab: [],
            name: "datagrid",
            columns: [
                "iniciales",
                "nombre",
                "username",
                "perfil",
                "estatus",
                "actions"
            ],
            show_loading: true,
            loading: false,
            options: {
                filterable: ["iniciales","nombre", "username",   "perfil","estatus"],
                sortable: ["iniciales","nombre", "username",  "perfil","estatus"],
                initFilters: {"estatus":'true'},
                headings: {
                    Iniciales:"iniciales",
                    nombre: "Nombre",
                    username: "Email",
                    perfil: "Perfil",
                    estatus: "Estatus",
                    actions: "Operaciones"
                },
                
                listColumns: {
                    estatus: [{
                            id: true,
                            text: "Activos"
                        },
                        {
                            id: false,
                            text: "Inactivos"
                        },
                        {
                            id: null,
                            text: "Todos"
                        }
                    ],
                    tipo_usuario: [],
                    grupo: [],
                    perfil: []
                }
            },

            breadcrumbs: [{
                    text: "Administración",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "Usuarios",
                    disabled: true,
                    href: ""
                }
            ],

            modal_cliente: false,
            clientes: [],
            id_cliente: "",
            id_usuario_seleccionado: "",
            nombre_usuario_seleccionado: "",

            title: "",
            modal: false,
            update: false,
            tipos_usuario: [],
            grupos: [],
            perfiles: [],
            model: {
                id_usuario: "",
                username: "",
                password: "",
                nombre: "",
                apellidos: "",
                iniciales: "",
                tipo_usuario: "",
                grupo: "",
                perfil: "",
                estatus: true,
                
            },
            rules: {
                required: v => !!v || "Este campo es requerido",
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Correo electrónico no valido";
                },
                rfclen: v =>
                    (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres"
            },
            search: "",
            usuarios: {
                camposexcel: {
                    Correo: "username",
                    Nombre: "nombre",
                    Apellidos: "apellidos",
                    Iniciales: "iniciales",
                    Estatus: "estatus_nombre",
                },
                items: []
            }
        };
    },
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.usuarios.items;
            }

        },
    },
    methods: {
        getNombreTipoUsuario: function (id_tipo_usuario) {
            let tipo = this.tipos_usuario.filter(tipo => {
                return tipo.id_tipo_usuario == id_tipo_usuario;
            });

            if (tipo.length === 1) return tipo[0].nombre;
        },

        getNombreGrupo: function (id_grupo) {
            let grupo = this.grupos.filter(grupo => {
                return grupo.id_grupo == id_grupo;
            });

            if (grupo.length === 1) return grupo[0].nombre;
        },
        getNombrePerfil: function (id) {
            let search = this.perfiles.filter(e => {
                return e.id_perfil == id;
            });

            if (search.length > 0) 
                return search[0].nombre;
            else 
                return 'ADMINISTRADOR';
        },
        openModal: function (type) {
            if (type === 1) {
                this.title = "Nuevo Usuario";
                this.update = false;
                this.model.username = "";
                this.model.password = "";
                this.model.nombre = "";
                this.model.apellidos = "";
                this.model.iniciales = "";
                this.model.tipo_usuario = "";
                this.model.grupo = "";
                this.model.perfil = "";
            } else {
                this.title = "Actualizar Usuario";
                this.update = true;
            }

            this.modal = true;
        },
        openModalCliente: function(id_usuario, nombre, apellidos){
            try {
                this.id_cliente = "";
                this.id_usuario_seleccionado = id_usuario;
                this.nombre_usuario_seleccionado = nombre +" "+ apellidos;
                this.modal_cliente = true;
            } catch (error) {
                console.log(error);
            }
        },  
        openModalPermisos: function (perfil) {
            if (perfil === null)
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "El usuario no tiene un perfil asignado.",
                    footer: ""
                });
            else {
                this.titleModalPermisos = "Permisos del Perfil: " + this.getNombrePerfil(perfil);
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let data = {
                    cliente: 0,
                    sistema: this.$sistema,
                    id_perfil: perfil
                };

                axios
                    .post(this.$hostname + "perfiles/get_permisos_perfil/", data)
                    .then(response => {                        
                        this.permisos_perfiles = this.filtrarPermisosActivos(response.data);
                        this.modal_permisos = true;
                    })
                    .catch(error => {                        
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los permisos.",
                            footer: ""
                        });
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        filtrarPermisosActivos: function (arr) {
            return arr.filter(function (ele) {
                    return ele.activo == 1;
                }).sort(this.ordenarArrayPermisos);
        },
        ordenarArrayPermisos: function (a, b) {
            if (a.ordenar > b.ordenar) return 1;
            if (a.ordenar < b.ordenar) return -1;
            return 0;
        },
        convertirUsuario: function(){
            if (this.$refs.formCliente.validate()) {
                this.$swal({
                    type: "info",
                    title: "Atención",
                    text: "Al hacer el cambio, el usuario se deslindará del grupo al que pertenece y pertenecerá al cliente seleccionado. "+
                            "El usuario ya no será visible en esta lista. ¿Desea continuar?",
                    footer: "",
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar"
                }).then(result => {
                    if (result.value){
                        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                        let data = {
                            id_cliente: this.id_cliente,
                            id_usuario: this.id_usuario_seleccionado,
                        };
                        axios.post(this.$hostname + "clientes/convertir_acliente/", data)
                            .then(response => {
                                this.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El registro se actualizó correctamente.",
                                    footer: ""
                                });

                                this.modal_cliente = false;
                                this.getUsuarios();
                            })
                            .catch(error => {
                                var mensaje = "Ocurrió un error al actualizar el registro. Favor de comunicarse con soporte.";
                                if (typeof error.response != "undefined") {
                                    
                                    if (error.response.data != undefined){
                                        if (error.response.data.mensaje!=undefined)
                                            for(var k in error.response.data.mensaje)
                                                mensaje = error.response.data.mensaje[k];                                
                                    }
                                }
                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: mensaje,
                                    footer: ""
                                });
                            })
                            .then(() => {
                                this.$root.$dialogLoader.hide();
                            });
                    }                    
                });
            }              
        },
        getUsuarios: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "usuarios/")
                .then(response => {
                    let tipos_usuario = this.tipos_usuario;

                    let datos = response.data.filter(function (usuario) {
                        let usuarios = tipos_usuario.filter(tipo => {
                            return tipo.id_tipo_usuario == usuario.tipo_usuario;
                        });

                        return usuarios.length > 0;
                    });

                    this.usuarios.items = datos;
                    for (var k in this.usuarios.items) {
                        this.usuarios.items[k].grupo_nombre = this.getNombreGrupo(this.usuarios.items[k].grupo);
                        this.usuarios.items[k].tipo_usuario_nombre = this.getNombreTipoUsuario(this.usuarios.items[k].tipo_usuario);
                        this.usuarios.items[k].estatus_nombre = this.usuarios.items[k].estatus == true ? 'Activo' : 'Inactivo';
                    }
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getClientes: function () {
            axios.get(this.$hostname + "clientes/")
                .then(response => {
                    this.clientes = response.data;

                    var clientesActivos = this.clientes.filter(cliente => {
                        return cliente.estatus == 1;
                    });

                    this.clientes = clientesActivos;                    
                })
                .catch(error => {                    
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                });
        },
        getGrupos: function () {
            axios
                .get(this.$hostname + "grupos/")
                .then(response => {
                    this.grupos = response.data;
                    let changesMap = {
                        id_grupo: "id",
                        nombre: "text"
                    };
                    this.options.listColumns.grupo = objectRenameKeys(
                        response.data,
                        changesMap
                    );
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los grupos.",
                        footer: ""
                    });
                });
        },
         getPerfiles: function () {
            axios
                .get(this.$hostname + "perfiles/")
                .then(response => {
                    this.perfiles = response.data;                    
                    let changesMap = {
                        id_perfil: "id",
                        nombre: "text"
                    };
                    this.options.listColumns.perfil = objectRenameKeys(
                        response.data,
                        changesMap
                    );
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los perfiles.",
                        footer: ""
                    });
                });
        },
        getTiposUsuario: function () {
            axios
                .post(this.$hostname + "tipos-usuarios/get_all/")
                .then(response => {
                    let datos = response.data.filter(function (tipo) {
                        return (
                            tipo.nombre == "Super Usuario" ||
                            tipo.nombre == "Asuntos Legales" ||
                            tipo.nombre == "Pagos" ||
                            tipo.nombre == "Soporte"
                        );
                    });

                    this.tipos_usuario = datos;
                    let changesMap = {
                        id_tipo_usuario: "id",
                        nombre: "text"
                    };
                    this.options.listColumns.tipo_usuario = objectRenameKeys(
                        datos,
                        changesMap
                    );
                    this.getUsuarios();
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los tipos de usuario.",
                        footer: ""
                    });
                });
        },
        getUsuario: function (id_usuario) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "usuarios/" + id_usuario + "/")                
                .then(response => {
                    this.model = response.data;
                    this.openModal(2);
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener al usuario",
                        footer: ""
                    });
                }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });
        },
        saveUsuario: function () {
            if (this.$refs.form.validate()) {
                this.model.password = this.model.username;
                if (this.model.tipo_usuario != 4)
                    //Si no es de grupo, limpiamos el grupo en caso de que haya quedado
                    this.model.grupo = null;
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                axios
                    .post(this.$hostname + "usuarios/", this.model)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El usuario se creó correctamente.",
                            footer: ""
                        });

                        this.modal = false;
                        this.getUsuarios();
                    })
                    .catch(error => {
                        var mensaje = "Ocurrió un error al crear el usuario. Favor de comunicarse con soporte.";
                        if (typeof error.response != "undefined") {
                            
                            if (error.response.data != undefined){
                                if (error.response.data.mensaje!=undefined)
                                    for(var k in error.response.data.mensaje)
                                        mensaje = error.response.data.mensaje[k];
                            
                                if (error.response.data.username!=undefined)
                                    for(var k in error.response.data.username)
                                        mensaje = error.response.data.username[k];
                                
                            }
                        }
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: ""
                        });
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        updateUsuario: function () {
            let id_usuario = this.model.id_usuario;

            if (this.$refs.form.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                if (this.model.tipo_usuario != 4) {
                    //Si no es de grupo, limpiamos el grupo en caso de que haya quedado
                    this.model.grupo = null;
                    this.model.perfil = null;
                }
                let data = {
                    //   username: this.model.username,
                    nombre: this.model.nombre,
                    apellidos: this.model.apellidos,
                    iniciales: this.model.iniciales,
                    tipo_usuario: this.model.tipo_usuario,
                    grupo: this.model.grupo,
                    perfil: this.model.perfil==undefined?"":this.model.perfil,
                };
                
                axios
                    .put(this.$hostname + "usuarios/" + id_usuario + "/", data)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El usuario se actualizó correctamente.",
                            footer: ""
                        });

                        this.getUsuarios();
                        this.modal = false;
                    })
                    .catch(error => {
                        if (typeof error.response != "undefined") {
                            let msj = error.response.data.detail;
                            if (msj === undefined) msj = error.response.data.username;

                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: msj,
                                footer: ""
                            });
                        } else {
                            console.log(error);
                        }
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        deleteUsuario: function (id_usuario) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value)
                    axios
                    .delete(this.$hostname + "usuarios/" + id_usuario + "/", {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "cache-control": "no-cache"
                    })
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El usuario se eliminó correctamente.",
                            footer: ""
                        });

                        this.getUsuarios();
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar al usuario",
                            footer: ""
                        });
                    });
            });
        },
        resetPassword: function (id_usuario, email) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Realmente desea resetear la contraseña?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value)
                    axios
                    .put(
                        this.$hostname + "usuarios/" + id_usuario + "/", {
                            password: email
                        }, {
                            "Content-type": "application/json",
                            "Access-Control-Allow-Origin": "*",
                            "cache-control": "no-cache"
                        }
                    )
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "La contraseña se reseteó correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al resetear la contraseña",
                            footer: ""
                        });
                    });
            });
        },
        changeEstatus: function (id_usuario, estatus) {
            let msj = estatus ? "Activar" : "Desactivar";

            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de " + msj + " el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value)
                    axios
                    .put(
                        this.$hostname + "usuarios/" + id_usuario + "/", {
                            estatus: estatus
                        }, {
                            "Content-type": "application/json",
                            "Access-Control-Allow-Origin": "*",
                            "cache-control": "no-cache"
                        }
                    )
                    .then(response => {
                        this.getUsuarios();
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cambiar el estatus al usuario",
                            footer: ""
                        });
                    });
            });
        },
        logout: function function_name(id_usuario) {
            var data = {
                usuario: id_usuario,
                sistema: this.$sistema,
                avatar: "undefined"
            };

            var url = this.$hostname + "usuarios/logout/";
            var self = this;

            axios
                .post(url, data)
                .then(function (response) {
                    self.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "La sesión del usuario se cerro correctamente",
                        footer: ""
                    });
                })
                .catch(function (error) {
                    self.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al cerrar la sesión",
                        footer: ""
                    });
                });
        }
    }
};
</script>
